export default "__VITE_ASSET__DoZ6VCDt__"